import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { getContent } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import MasterDataUserMenu from '../../../components/MasterData/MasterDataUserMenu';
import MasterDataUserFirstPage from '../../../components/MasterData/MasterDataUserFirstPage';
import MasterDataUserSecondPage from '../../../components/MasterData/MasterDataUserSecondPage';
import MasterDataUserThirdPage from '../../../components/MasterData/MasterDataUserThirdPage';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import API_MASTER_DATA from '../../../api/apiMasterData';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_USER_VIEW } from '../../../constants/menuPermissionConstant';
import API_AUTHENTICATION from '../../../api/apiAuthentication';

class UserDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            userCategory: {
                data: [
                    {
                        value: 'nexsoft',
                        label: 'Nexsoft'
                    },
                    {
                        value: 'distributor',
                        label: 'Distributor'
                    },
                    {
                        value: 'principal',
                        label: 'Principal'
                    }
                ],
                value: ''
            },
            isCustomerService: false,
            assignable: false,
            email: '',
            language: {
                placeholder: 'Indonesia',
                value: 'id-ID'
            },
            level: {
                data: [
                    {
                        value: 'cslv1',
                        label: 'Level 1'
                    },
                    {
                        value: 'cslv2',
                        label: 'Level 2'
                    }
                ],
                value: ''
            },
            specialization: {
                page: 1,
                limit: 100,
                data: [],
                value: []
            },
            lead: {
                data: [],
                value: ''
            },
            isLead: false,
            distributor: {
                data: [],
                value: []
            },
            idCard: '',
            title: {
                data: [
                    {
                        value: 'Tn',
                        label: 'Tn'
                    },
                    {
                        value: 'Ny',
                        label: 'Ny'
                    },
                    {
                        value: 'Nn',
                        label: 'Nn'
                    }
                ],
                value: ''
            },
            firstName: '',
            lastName: '',
            gender: {
                data: [
                    {
                        value: 'L',
                        label: 'Laki-Laki'
                    },
                    {
                        value: 'P',
                        label: 'Perempuan'
                    }
                ],
                value: ''
            },
            countryCode: '+62',
            phoneNumber: '',
            createdAt: '',
            updatedAt: '',
            updatedBy: '',
            status: false,
            username: '',
            password: '',
            confirmPassword: '',
            role: {
                data: [],
                value: ''
            },
            dataGroup: {
                data: [],
                value: ''
            },
            detailUser: '',
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getDetailUser = () => {
        API_MASTER_DATA.getDetailUser(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let userCategory = ''
                    if (getContent(res).level === 'cso') {
                        userCategory = {
                            value: 'cso',
                            label: 'Nexsoft'
                        }
                        this.setState({ isCustomerService: true })
                    }
                    if (getContent(res).level === 'super_admin') {
                        userCategory = {
                            value: 'nexsoft',
                            label: 'Nexsoft'
                        }
                        this.setState({ isCustomerService: true })
                    }
                    if (getContent(res).level === 'nexsoft') {
                        userCategory = {
                            value: 'nexsoft',
                            label: 'Nexsoft'
                        }
                        this.setState({ isCustomerService: true })
                    }
                    if (getContent(res).level === 'distributor') {
                        userCategory = {
                            value: 'distributor',
                            label: 'Distributor'
                        }
                    }
                    if (getContent(res).level === 'principal') {
                        userCategory = {
                            value: 'principal',
                            label: 'Principal'
                        }
                    }

                    let csLevel = ''
                    if (getContent(res).cs_level === 'cslv1') {
                        csLevel = {
                            value: 'cslv1',
                            label: 'cslv1'
                        }
                    }
                    if (getContent(res).cs_level === 'cslv2') {
                        csLevel = {
                            value: 'cslv2',
                            label: 'cslv2'
                        }
                    }

                    let complaintData = ''
                    if (getContent(res).specialities !== null) {
                        complaintData = getContent(res).specialities.map(complaint => ({
                            value: complaint.id,
                            label: complaint.complaint
                        }))
                    }

                    let lead = ''
                    if (getContent(res).lead_id !== 0 && getContent(res).leader_name !== '') {
                        lead = {
                            value: getContent(res).lead_id,
                            label: getContent(res).leader_name
                        }
                    }

                    let distributor = ''
                    if (getContent(res).list_distributor !== null) {
                        distributor = getContent(res).list_distributor.map(distributor => ({
                            value: distributor.id,
                            label: distributor.name
                        }))
                    }

                    let title = ''
                    if (getContent(res).title !== '') {
                        title = {
                            value: getContent(res).title,
                            label: getContent(res).title
                        }
                    }

                    let gender = ''
                    if (getContent(res).gender === 'L') {
                        gender = {
                            value: 'L',
                            label: 'Laki-Laki'
                        }
                    }
                    if (getContent(res).gender === 'P') {
                        gender = {
                            value: 'P',
                            label: 'Perempuan'
                        }
                    }
                    if (getContent(res).gender === 'N') {
                        gender = {
                            value: 'N',
                            label: 'Tidak Diketahui'
                        }
                    }

                    let phoneNumber = ''
                    if (getContent(res).phone.includes('-')) {
                        phoneNumber = getContent(res).phone.replaceAll('-', '')
                        if (getContent(res).phone.includes('+62-')) {
                            phoneNumber = getContent(res).phone.replaceAll('+62-', '')
                        }
                        if (phoneNumber[0] === '0') {
                            phoneNumber = phoneNumber.slice(1, phoneNumber.length)
                        }
                    } else if (getContent(res).phone.includes('+62')) {
                        phoneNumber = getContent(res).phone.replaceAll('+62', '')
                    } else if (phoneNumber[0] === '0') {
                        phoneNumber = phoneNumber.slice(1, phoneNumber.length)
                    } else {
                        phoneNumber = getContent(res).phone
                    }

                    this.setState({
                        assignable: getContent(res).assignable,
                        detailUser: getContent(res),
                        id: getContent(res).id,
                        userCategory: {
                            ...this.state.userCategory,
                            value: userCategory
                        },
                        email: getContent(res).email,
                        level: {
                            ...this.state.level,
                            value: csLevel
                        },
                        specialization: {
                            ...this.state.specialization,
                            value: complaintData
                        },
                        lead: {
                            ...this.state.lead,
                            value: lead
                        },
                        isLead: getContent(res).is_lead,
                        distributor: {
                            ...this.state.distributor,
                            value: distributor
                        },
                        idCard: getContent(res).id_card,
                        title: {
                            ...this.state.title,
                            value: title
                        },
                        firstName: getContent(res).first_name,
                        lastName: getContent(res).last_name,
                        gender: {
                            ...this.state.gender,
                            value: gender
                        },
                        phoneNumber: phoneNumber,
                        username: getContent(res).username,
                        password: '',
                        confirmPassword: '',
                        role: {
                            ...this.state.role,
                            value: {
                                value: getContent(res).role_id,
                                label: getContent(res).role_name
                            }
                        },
                        dataGroup: {
                            ...this.state.dataGroup,
                            value: {
                                value: getContent(res).data_group_id,
                                label: getContent(res).data_group_name
                            }
                        },
                        createdAt: moment.utc(getContent(res).created_at).format('DD MMMM YYYY HH:mm'),
                        updatedAt: moment.utc(getContent(res).updated_at).format('DD MMMM YYYY HH:mm'),
                        updatedBy: getContent(res).modified_by,
                        status: getContent(res).status,
                    })
                    this.getDetailUserAuthentication(getContent(res).email, getContent(res).phone);
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getDetailUserAuthentication = (email, phone) => {
        const dataEmail = {
            email: email
        }

        API_AUTHENTICATION.postDetailUser(dataEmail, this.props.token)
            .then(res => {
                if (getContent(res).client_id !== '') {
                    this.setState({ emailVerified: true })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })

        const dataPhone = {
            phone: this.state.countryCode + "-" + phone
        }

        API_AUTHENTICATION.postDetailUser(dataPhone, this.props.token)
            .then(res => {
                if (getContent(res).client_id !== '') {
                    this.setState({ phoneVerified: true })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangePage = page => {
        this.setState({ page })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = () => {
        this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_USER)
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailUser();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="user user-detail">
                    <MasterDataUserMenu
                        page={this.state.page}
                        handleChangePage={this.handleChangePage}
                    />

                    <div className={this.state.page === 1 ? "block" : "hidden"}>
                        <MasterDataUserFirstPage
                            page={this.state.page}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            detailUser={this.state.detailUser}
                            id={this.state.id}
                            userCategory={this.state.userCategory}
                            isCustomerService={this.state.isCustomerService}
                            assignable={this.state.assignable}
                            email={this.state.email}
                            language={this.state.language}
                            level={this.state.level}
                            specialization={this.state.specialization}
                            lead={this.state.lead}
                            isLead={this.state.isLead}
                            distributor={this.state.distributor}
                            idCard={this.state.idCard}
                            title={this.state.title}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            gender={this.state.gender}
                            countryCode={this.state.countryCode}
                            phoneNumber={this.state.phoneNumber}
                            createdAt={this.state.createdAt}
                            updatedAt={this.state.updatedAt}
                            updatedBy={this.state.updatedBy}
                            status={this.state.status}
                            emailVerified={this.state.emailVerified}
                            phoneVerified={this.state.phoneVerified}
                            action="detail"
                        />
                    </div>
                    <div className={this.state.page === 2 ? "block" : "hidden"}>
                        <MasterDataUserSecondPage
                            page={this.state.page}
                            username={this.state.username}
                            password={this.state.password}
                            confirmPassword={this.state.confirmPassword}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            action="detail"
                        />
                    </div>
                    <div className={this.state.page === 3 ? "block" : "hidden"}>
                        <MasterDataUserThirdPage
                            page={this.state.page}
                            role={this.state.role}
                            dataGroup={this.state.dataGroup}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            handleSubmit={this.handleSubmit}
                            action="detail"
                        />
                    </div>
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);